import moment from 'moment';
import 'moment-timezone-with-data-2010-2020';
import TokenSession from "core/util/session/TokenSession";

export default class TimezoneUtil {

	public static convertToUserTimezone(dateString: string): string {
		if (!dateString) return dateString;

		try {
			const context = TokenSession.getContext();
			const userTimezone = context && context.timeZone;

			if (userTimezone) {
				// Parse the date and convert to user's timezone
				const dateInUserTz = moment.tz(dateString, userTimezone);
				
				// Get the local browser timezone offset
				const browserOffset = moment().utcOffset();
				// Get the user timezone offset
				const userOffset = dateInUserTz.utcOffset();
				// Calculate the difference
				const offsetDiff = userOffset - browserOffset;
				
				// Adjust the date by the offset difference so when DateLabel renders it,
				// it will display the correct time in the user's timezone
				return moment(dateString).add(offsetDiff, 'minutes').toISOString();
			}

			// Fallback to original date if user timezone is not available
			return dateString;
		} catch (error) {
			console.error('Error converting timezone:', error);
			return dateString;
		}
	}

	public static convertDateForSubscription(dateString: string): string {
		return TimezoneUtil.convertToUserTimezone(dateString);
	}
}



// WEBPACK FOOTER //
// ./src/core/util/TimezoneUtil.ts